var AjaxInterceptor = require('./../ajax-interceptor');

function initAuthInterceptor(token) {
  AjaxInterceptor.addRequestCallback(function(xhr) {
    if (!xhr.requestHeaders || !xhr.requestHeaders['authorization']) {
      xhr.setRequestHeader('authorization', token);
    }
  });
}

export { initAuthInterceptor };
